<template>
  <span class="flowViewStatus" :class="`typeView${status}`">
    {{ statusName(status) }}
  </span>
</template>

<script>
export default {
  name: "FlowStatus",

  props: {
    status: {
      type: String,
      required: true,
      default: "0"
    }
  },

  methods: {
    statusName(status) {
      switch (status) {
        case "1":
          return "已通过";
        case "10":
          return "自动通过";
        case "2":
          return "审批中";
        case "3":
          return "发起";
        case "4":
          return "重新发起";
        case "5":
          return "已撤回";
        case "0":
          return "已驳回";
        default:
          return "";
      }
    }
  }
};
</script>

<style lang="less" rel="scss" scoped>
.flowViewStatus {
  border-radius: 6px;
  text-align: center;
  padding: 4px 6px;
  margin-left: 10px;
}

.typeView1,
.typeView3,
.typeView4 {
  background: rgba(0, 182, 50, 0.24);
  color: #00b632;
}
.typeView2 {
  background: rgba(243, 124, 38, 0.15);
  color: #f37c26;
}
.typeView {
  background: #70737e;
  color: #fff;
}

.typeView0 {
  background: rgba(236, 54, 42, 0.15);
  color: #ec3226;
}
</style>
